// Premium Class A — diesel pusher / luxury coach imagery.
//
// Iteration 109: Owner-approved Premium Class A photography landed via
// the canonical manifest (see /lib/photos/manifest.js).  This module now
// only exposes true owner-approved Premium Class A imagery (Newell,
// Entegra, Millennium, Foretravel Realm).  The previous black Prevost
// stand-in has been retired.
import { _ASSET_BASE } from "./_base";

const PCA_HERO      = `${_ASSET_BASE}/5dl7dm88_IMG_5610.jpeg`; // Newell · navy/silver · lot
const PCA_ACCENT    = `${_ASSET_BASE}/sofy8jiq_IMG_5611.jpeg`; // Entegra · black · dealer lot
const PCA_GALLERY_1 = `${_ASSET_BASE}/00l9basy_IMG_5612.jpeg`; // Newell · silver/black · blue sky
const PCA_GALLERY_2 = `${_ASSET_BASE}/jrfbj3t4_IMG_5615.jpeg`; // Millennium · hangar underlight
const PCA_GALLERY_3 = `${_ASSET_BASE}/cxh6dwp3_IMG_5616.jpeg`; // Foretravel Realm · studio

export const PREMIUM_CLASS_A_PHOTOS = [
  PCA_HERO,
  PCA_ACCENT,
  PCA_GALLERY_1,
  PCA_GALLERY_2,
  PCA_GALLERY_3,
];

const premiumClassA = {
  hero: PCA_HERO,
  accent: PCA_ACCENT,
  gallery: [PCA_GALLERY_1, PCA_GALLERY_2, PCA_GALLERY_3],
  card: PCA_HERO,
  social: PCA_HERO,
};
export default premiumClassA;
